/**
 * @generated SignedSource<<dbb90f8d6abf5cb235deedb5a6437f50>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleAssignmentTypesUpdateModal_setAssignmentTypesOnScheduleMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetAssignmentTypesOnSchedulePayload",
                    "kind": "LinkedField",
                    "name": "setAssignmentTypesOnSchedule",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfSchedule",
                            "kind": "LinkedField",
                            "name": "scheduleEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "ScheduleAssignmentTypesPanel_schedule"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleAssignmentTypesUpdateModal_setAssignmentTypesOnScheduleMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetAssignmentTypesOnSchedulePayload",
                    "kind": "LinkedField",
                    "name": "setAssignmentTypesOnSchedule",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfSchedule",
                            "kind": "LinkedField",
                            "name": "scheduleEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Schedule",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ScheduleAssignmentTypeConnection",
                                            "kind": "LinkedField",
                                            "name": "assignmentTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ScheduleAssignmentType",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "AssignmentType",
                                                            "kind": "LinkedField",
                                                            "name": "assignmentType",
                                                            "plural": false,
                                                            "selections": [
                                                                (v2 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "title",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "8a42b0d16bb65902e86e6e7aa9a6d878",
            "id": null,
            "metadata": {},
            "name": "ScheduleAssignmentTypesUpdateModal_setAssignmentTypesOnScheduleMutation",
            "operationKind": "mutation",
            "text": "mutation ScheduleAssignmentTypesUpdateModal_setAssignmentTypesOnScheduleMutation(\n  $model: SetAssignmentTypesOnScheduleRequestInput!\n) {\n  setAssignmentTypesOnSchedule(model: $model) {\n    scheduleEdge {\n      node {\n        ...ScheduleAssignmentTypesPanel_schedule\n        id\n      }\n    }\n  }\n}\n\nfragment AssignmentTypeChip_assignmentType on AssignmentType {\n  id\n  title\n}\n\nfragment ScheduleAssignmentTypesPanel_schedule on Schedule {\n  assignmentTypes {\n    nodes {\n      id\n      assignmentType {\n        ...AssignmentTypeChip_assignmentType\n        id\n      }\n    }\n  }\n  id\n}\n"
        }
    };
})();
node.hash = "7494d3a54ec4fecb6edd7f71cba44ad2";
export default node;
